import React from 'react';
import styled from 'styled-components';
import Header from '../../components/common/header/Header';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { reqEsItemInfoAction, reqEsOrderAction, reqEsOrderCodeReset } from '../../modules/od/orderModule';
import { setCurMenuAction, setHeaderTransferAction } from '../../modules/common/headerModule';
import { useState } from 'react';
import Footer from '../../components/common/Footer';
import { split, slice, truncate } from 'lodash';
import NormalInput from '../../components/common/input/NormalInput';
import SelectDropDownBtn from '../../components/common/button/SelectDropDownBtn';
import CheckBoxInput from '../../components/common/input/CheckBoxInput';
import BootPay from "bootpay-js";
import { OrderId, Log } from '../../lib/util/CustomUtil';
import TextArea from '../../components/common/textarea/TextArea';
import { useRef } from 'react';
import Modal from 'react-modal';
import NormalPopupOneBtn, { NomalPopupOneBtnStyles } from '../../components/common/popup/NormalPopupOneBtn';

import $ from 'jquery';

import {EsComItemList, EsComSummary} from '../../components/es/index'

import { isMobileOnly } from 'react-device-detect';

const inputWidth=isMobileOnly?"92vw":"430px";

const EsOrderBlock = styled.div`
  ${isMobileOnly ? `
    margin: 0 4vw;
  `
  : `
    width: 100%;
    margin: 0 auto;`};
`;

const EsOrderContentsBlock = styled.div`
    padding: 60px 0 120px;
    ${isMobileOnly&&`
        .product-table{
          margin: 10px 0;
          border-top: 2px solid #111;  
        }
        .border {
            border-top: 2px solid #111;
            &.tpad { padding-top: 20px;}
        }
        
        .ps-btn {
            text-align: center;
            
            &::before, &.card::before,&.send::before,&.live::before {
                display: block;               
                width: 100%;
                margin:0;            
            }            
        }
        .payment_wing-box {
            transition: unset;
            float: none;
            width: unset;
            padding-left: 0;            
        }
    `}
`;

const dvryOptions = [
    { value: 1, label: "선택하세요." },
    { value: 2, label: "배송전 연락바랍니다." },
    { value: 3, label: "부재 시 문앞에 놔주세요." },
    { value: 4, label: "부재 시 경비실에 맡겨주세요." },
    { value: 5, label: "직접 입력 " }
];
const EsOrder = ({ location }) => {

    const dispatch = useDispatch();
    const history = useHistory();

    const [revName, setRevName] = useState(""); // 수령인
    const [mobile1, setMobile1] = useState("010"); // 전화번호 1
    const [mobile2, setMobile2] = useState(""); // 전화번호 2
    const [mobile3, setMobile3] = useState(""); // 전화번호 3

    const [phone1, setPhone1] = useState("010"); // 전화번호 1
    const [phone2, setPhone2] = useState(""); // 전화번호 2
    const [phone3, setPhone3] = useState(""); // 전화번호 3

    const [mymobile1, setMyMobile1] = useState("");
    const [mymobile2, setMyMobile2] = useState("");
    const [mymobile3, setMyMobile3] = useState("");

    const [reqDlrv, setReqDlrv] = useState("");
    const [isTextArea, setIsTextArea] = useState(false);

    const [agree, setAgree] = useState(false);
    const [escrow, setEscrow] = useState(false);
    const [same, setSame] = useState(true);

    const [method, setMethod] = useState("card");

    const [openModal, setOpenModal] = useState(false);

    const recvNmRef = useRef(null);
    const mbRef1 = useRef(null);
    const mbRef2 = useRef(null);
    const mbRef3 = useRef(null);

    const { esItemInfo, esItemInfoRes, accessToken, curMenu, esOrderRes } = useSelector(
        ({ userReducer, esOrderReducer, headerReducer }) => ({
            accessToken: userReducer.accessToken,
            esItemInfoRes: esOrderReducer.esItemInfoRes,
            esItemInfo: esOrderReducer.esItemInfo,
            curMenu: headerReducer.curMenu,
            esOrderRes: esOrderReducer.esOrderRes,
        })
    );

    useEffect(() => {

        if (curMenu !== 'od') {
            dispatch(setCurMenuAction('od'));
            dispatch(setHeaderTransferAction(false));
            window.scrollTo(0, 0);
        }

        if (accessToken === null || location.search === null
            || location.search === undefined) {
            history.push("/notfound");
        }
    });

    useEffect(() => {
        dispatch(reqEsItemInfoAction(location.search));
    }, [location])

    useEffect(() => {
        const onScroll = () => {
            if (isMobileOnly) {
                return;
            }
            var $bar = $('.payment_wing-box');
            if($bar.length){

                var nowScroll = $(window).scrollTop();
                    var offset = $('.payment-wrap').offset().top;
                    var move = nowScroll - offset;

                    if ( move > 443 ) {
                        move = 443;
                    } else {
                        move = nowScroll - offset;
                    }

                    if ( nowScroll > offset ) {
                        $bar.css({'transform': 'translateY(' + move + 'px)', 'margin-top': '110px'});
                    } else {
                        $bar.css({'transform': 'none', 'margin-top': '0'});
                    }
            }
        };

        // scroll 이벤트를 만들어줍니다. 스크롤을 움직일때 마다
        // onScroll 함수가 실행됩니다.
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {
        if (esItemInfoRes === 600 || esItemInfoRes === 500) {
            dispatch(reqEsOrderCodeReset())
            history.push("/");
        } else if (esItemInfo !== null && esItemInfo !== undefined) {
            setRevName(esItemInfo.userinfo.rqst_nm);

            if (esItemInfo.userinfo.rqst_mo_no !== null) {
                setMyMobile1(getMobile(1));
                setMyMobile2(getMobile(2));
                setMyMobile3(getMobile(3));

                if (same) {
                    setMobile1(getMobile(1));
                    setMobile2(getMobile(2));
                    setMobile3(getMobile(3));
                }
            }
        }
    }, [esItemInfoRes])

    useEffect(() => {

        // 주문 완료 후 완료 페이지로 이동
        if (esOrderRes !== null) {
            history.push("/orderdone?odid=" + esOrderRes.data);
        }

    }, [esOrderRes])

    if (accessToken === null || esItemInfoRes === 600 || esItemInfoRes === 500) {
        dispatch(reqEsOrderCodeReset());
        history.push("/");
        // return <Redirect to="/" />
    }

    if (esItemInfoRes === null || esItemInfo === null) {
        return <EsOrderBlock />
    }


    const getDlvryPayInFooter = (item) => {

        // 착불
        if (item.es_detail_dlvry_pay_type === '025202' || item.es_dlvry_total_price > 0) {
            return (<span className="esd_pay">
                {Number(item.es_dlvry_total_price.toFixed(1)).toLocaleString()}원
            </span>)
        } else {
            return (<p className="pt-pay normal">무료 배송</p>)
        }
    }


    const isCashOnDlvryShow = (item) => {
        if (item.es_detail_dlvry_pay_type === '025202') {
            return { display: 'block' };
        } else {
            return { display: 'none' };
        }
    }

    const getDetailDlvry = (item) => {

        if (item.es_detail_dlvry_fee > 0) {
            return (<p className="fontsize-14">
                {Number(item.es_detail_dlvry_fee.toFixed(1)).toLocaleString()}원</p>)
        } else {
            return (<div>
                <p className="fontsize-14">무료</p>
            </div>)
        }
    }

    const getCateName = (cate_name) => {

        if (cate_name !== null) {
            let catenames = split(cate_name, '>');
            return catenames[1];
        }

        return "";
    }


    const getDscntPercent = (item) => {

        if (item.es_detail_dscnt_per > 0) {
            return (<p><span className="dotted-tag red"><span>{item.es_detail_dscnt_per}</span>%</span></p>);
        } else {
            return ("");
        }
    }

    const getDscntPriceNoDot = (item) => {
        if (item.es_detail_dscnt_per > 0 || item.es_detail_dscnt_price > 0) {
            return (<p className={item.es_detail_add_dscnt_price > 0 ? "sale_plus pink fontsize-14" : "pink fontsize-14"}>
                <span className="font-mont">
                    -{Number(item.es_detail_dscnt_price.toFixed(1)).toLocaleString()}</span>원</p>)
        } else {
            return ("");
        }
    }

    const getAddDscntPrice = (item) => {

        if (item.es_detail_add_dscnt_price > 0) {
            return (<p className="pink fontsize-14">
                <span>추가할인</span><br />
                <span className="font-mont">-
                {Number(item.es_detail_add_dscnt_price.toFixed(1)).toLocaleString()}</span>원
            </p>);
        } else {
            return ("");
        }
    }

    const getTotalDsctPrice = (item) => {
        return (Number(item.es_dscnt_total_price.toFixed(1)).toLocaleString());
    }

    const hanldeRevNameInput = (e) => {
        setRevName(e.target.value);
    }

    const handleMobile1 = (e) => {
        setMobile1(e.target.value);
    }

    const handleMobile2 = (e) => {
        setMobile2(e.target.value);
    }

    const handleMobile3 = (e) => {
        setMobile3(e.target.value);
    }

    const handlePhone1 = (e) => {
        setPhone1(e.target.value);
    }

    const handlePhone2 = (e) => {
        setPhone2(e.target.value);
    }

    const handlePhone3 = (e) => {
        setPhone3(e.target.value);
    }

    const handlerChangeDvryOption = (param) => {

        if (param.value === 5) {
            setReqDlrv("");
            setIsTextArea(true);
        } else {
            if (param.value === 1) {
                setReqDlrv("");
            } else {
                setReqDlrv(param.label);
            }

            setIsTextArea(false);
        }

    }

    const handleDvryText = (e) => {
        setReqDlrv(e.target.value);
    }

    const handleAgreeClick = (param) => {
        setAgree(param);
    }

    const handleEscrowClick = (param) => {
        setEscrow(param);
    }

    const getPayPrice = () => {
        return esItemInfo.items[0].es_pay_price;
    }

    const checkValid = () => {

        if (agree === false) {
            return false;
        }

        if (mobile1 === "" || mobile2 === "" || mobile3 === "") {
            return false;
        }

        if (revName === "") {
            return false;
        }

        return true;
    }

    const handleMethodClick = (param) => {
        setMethod(param);
    }

    const handleSameOrderInfo = (param) => {
        console.log("recvNmRef  :  " + recvNmRef.current.value);
        setSame(param);

        if (param === false) {
            recvNmRef.current.value = "";
            mbRef1.current.value = "";
            mbRef2.current.value = "";
            mbRef3.current.value = "";
            setMobile1("");
            setMobile2("");
            setMobile2("");
            setRevName("");
        } else {
            recvNmRef.current.value = esItemInfo.userinfo.rqst_nm;
            mbRef1.current.value = getMobile(1);
            mbRef2.current.value = getMobile(2);
            mbRef3.current.value = getMobile(3);
            setMobile1(getMobile(1));
            setMobile2(getMobile(2));
            setMobile2(getMobile(3));
            setRevName(esItemInfo.userinfo.rqst_nm);
        }
    }

    const getRecvName = () => {

        if (same) {
            return esItemInfo.userinfo.rqst_nm;
        } else {
            return "";
        }
    }

    const getMobile = (param) => {

        if (esItemInfo.userinfo.rqst_mo_no === null) {
            return "";
        }

        let length = esItemInfo.userinfo.rqst_mo_no.length;
        let scndEnd = length - 4;

        if (param === 1) {
            return esItemInfo.userinfo.rqst_mo_no.substring(0, 3);
        } else if (param === 2) {
            return esItemInfo.userinfo.rqst_mo_no.substring(3, scndEnd);
        } else if (param === 3) {
            return esItemInfo.userinfo.rqst_mo_no.substring(scndEnd, length);
        } else {
            return "";
        }
    }

    const handleSubmit = () => {

        // Log("reqDlrv : " +  reqDlrv)
        if (!checkValid()) {
            setOpenModal(true);
            return;
        }


        const odid = OrderId();
        BootPay.request({
            price: getPayPrice(), //실제 결제되는 가격
            application_id: process.env.REACT_APP_BOOTPAY_ID,
            name: "[" + process.env.REACT_APP_BOOTPAY_NAME + "] " + esItemInfo.userinfo.pckg_nm, //결제창에서 보여질 이름
            pg: 'inicis',
            method: method, //결제수단, 입력하지 않으면 결제수단 선택부터 화면이 시작합니다.
            show_agree_window: 0, // 부트페이 정보 동의 창 보이기 여부
            user_info: {
                username: esItemInfo.userinfo.rqst_nm,
                email: esItemInfo.userinfo.rqst_id,
                addr: esItemInfo.userinfo.addr1 + esItemInfo.userinfo.addr2,
                phone: esItemInfo.userinfo.rqst_mo_no
            },
            order_id: odid, //고유 주문번호로, 생성하신 값을 보내주셔야 합니다.
            params: {
                es_id: esItemInfo.items[0].es_id,
                es_rqst_id: esItemInfo.items[0].es_rqst_id,
                method: method,
                price: getPayPrice(),
                rqst_nm: esItemInfo.userinfo.rqst_nm,
                rqst_id: esItemInfo.userinfo.rqst_id,
                pckg_nm: esItemInfo.userinfo.pckg_nm,
                brnd_han: esItemInfo.brandinfo.brnd_han
            },
            extra: {
                escrow: escrow
            }
        }).error(function (data) {
            //결제 진행시 에러가 발생하면 수행됩니다.
            // console.log(data);
        }).cancel(function (data) {
            //결제가 취소되면 수행됩니다.
            // console.log(data);
        }).ready(function (data) {
            // 가상계좌 입금 계좌번호가 발급되면 호출되는 함수입니다.
            // console.log(data);
            // 주문서 등록 api 호출
            dispatch(
                reqEsOrderAction(
                    esItemInfo.items[0].es_id,
                    revName,
                    mobile1 + mobile2 + mobile3,
                    phone1 + phone2 + phone3,
                    reqDlrv,
                    data)
            );

        }).confirm(function (data) {
            //결제가 실행되기 전에 수행되며, 주로 재고를 확인하는 로직이 들어갑니다.
            //주의 - 카드 수기결제일 경우 이 부분이 실행되지 않습니다.
            // console.log(data);
            var enable = true; // 재고 수량 관리 로직 혹은 다른 처리
            if (enable) {
                BootPay.transactionConfirm(data); // 조건이 맞으면 승인 처리를 한다.
            } else {
                BootPay.removePaymentWindow(); // 조건이 맞지 않으면 결제 창을 닫고 결제를 승인하지 않는다.
            }
        }).close(function (data) {
            // 결제창이 닫힐때 수행됩니다. (성공,실패,취소에 상관없이 모두 수행됨)
            // console.log(data);
        }).done(function (data) {
            //결제가 정상적으로 완료되면 수행됩니다
            //비즈니스 로직을 수행하기 전에 결제 유효성 검증을 하시길 추천합니다.
            // console.log(data);

            // 주문서 등록 api 호출
            dispatch(
                reqEsOrderAction(
                    esItemInfo.items[0].es_id,
                    revName,
                    mobile1 + mobile2 + mobile3,
                    phone1 + phone2 + phone3,
                    reqDlrv,
                    data)
            );

        });
    }

    return (
        <EsOrderBlock>
            <Header />
            <EsOrderContentsBlock>
                {isMobileOnly?
                  <div className="small-section">
                          <div className="pay-title small clearfix">
                              <h2 className="f-left">견적서 주문</h2>
                          </div>

                          <div className="es_title-box margin_b-70">
                              <h3 className="es_title_sub">{esItemInfo.userinfo.pckg_nm}</h3>
                          </div>

                          <div className="flex vc jsb">
                              <div>{esItemInfo.brandinfo.brnd_han}</div>
                              <div>{esItemInfo.userinfo.es_rqst_id}</div>
                          </div>

                          <div className="product-table default-table">
                              <EsComItemList items={esItemInfo.items} />
                          </div>

                          <div className="payment-wrap clearfix margin_t-40">

                              <div className="">

                                  <div className="default-table margin_b-50">
                                      <div className="flex vc jsb">
                                          <h3 className="dt-title">배송지 정보</h3>
                                          <div className="margin_b-10">
                                              <CheckBoxInput
                                                labelmargin="0px 0px 0px 10px"
                                                title="주문자 정보와 동일"
                                                onClick={handleSameOrderInfo}
                                                defaultValue={same} />
                                          </div>
                                      </div>
                                      <div className="input-box border">
                                          <div className="clearfix margin_b-10">
                                              <p className="f-left">
                                                  <label htmlFor="" className="pro_dt-label">배송 지역</label>
                                              </p>
                                              <div className="f-left">
                                                  <NormalInput
                                                    type="text"
                                                    width={inputWidth}
                                                    defaultValue={esItemInfo.userinfo.addr1}
                                                    disabled={true}
                                                    marginBottom='10px'
                                                  />
                                                  <NormalInput
                                                    type="text"
                                                    width={inputWidth}
                                                    defaultValue={esItemInfo.userinfo.addr2}
                                                    disabled={true}
                                                    marginBottom='10px'
                                                  />
                                                  <span className="ess_text">*배송 주소로 견적이 진행되어 변경 불가합니다</span>
                                              </div>
                                          </div>

                                          <div className="clearfix margin_b-10">
                                              <p className="f-left">
                                                  <label htmlFor="" className="pro_dt-label">수령인</label>
                                              </p>
                                              <div className="f-left">
                                                  <NormalInput
                                                    inputRef={recvNmRef}
                                                    type="text"
                                                    width={inputWidth}
                                                    defaultValue={getRecvName()}
                                                    marginBottom='10px'
                                                    onChange={hanldeRevNameInput}
                                                  />
                                              </div>
                                          </div>
                                          <div className="clearfix margin_b-10">
                                              <p className="f-left">
                                                  <label htmlFor="" className="pro_dt-label">연락처 1</label>
                                              </p>
                                              <div className="f-left clearfix">
                                                  <div style={{ display: 'inline-block' }}>
                                                      <NormalInput
                                                        inputRef={mbRef1}
                                                        type="text"
                                                        width="80px"
                                                        defaultValue={mobile1}
                                                        marginBottom='10px'
                                                        maxLength="3"
                                                        onChange={handleMobile1}
                                                      />
                                                  </div>

                                                  <span className="tell-hp">-</span>
                                                  <div style={{ display: 'inline-block' }} >
                                                      <NormalInput
                                                        inputRef={mbRef2}
                                                        defaultValue={mobile2}
                                                        type="text"
                                                        width="80px"
                                                        marginBottom='10px'
                                                        maxLength="4"
                                                        onChange={handleMobile2}
                                                      />
                                                  </div>

                                                  <span className="tell-hp">-</span>
                                                  <div style={{ display: 'inline-block' }} >
                                                      <NormalInput
                                                        inputRef={mbRef3}
                                                        defaultValue={mobile3}
                                                        type="text"
                                                        width="80px"
                                                        marginBottom='10px'
                                                        maxLength="4"
                                                        onChange={handleMobile3}
                                                      />
                                                  </div>
                                              </div>
                                          </div>

                                          <div className="clearfix margin_b-10">
                                              <p className="f-left">
                                                  <label htmlFor="" className="pro_dt-label">연락처 2</label>
                                              </p>
                                              <div className="f-left clearfix">
                                                  <div style={{ display: 'inline-block' }}>
                                                      <NormalInput
                                                        type="text"
                                                        width="80px"
                                                        defaultValue="010"
                                                        marginBottom='10px'
                                                        onChange={handlePhone1}
                                                      />
                                                  </div>

                                                  <span className="tell-hp">-</span>
                                                  <div style={{ display: 'inline-block' }} >
                                                      <NormalInput
                                                        type="text"
                                                        width="80px"
                                                        marginBottom='10px'
                                                        onChange={handlePhone2}
                                                      />
                                                  </div>

                                                  <span className="tell-hp">-</span>
                                                  <div style={{ display: 'inline-block' }} >
                                                      <NormalInput
                                                        type="text"
                                                        width="80px"
                                                        marginBottom='10px'
                                                        onChange={handlePhone3}
                                                      />
                                                  </div>
                                              </div>
                                          </div>

                                          <div className="clearfix">
                                              <p className="f-left">
                                                  <label htmlFor="" className="pro_dt-label">배송 요청사항</label>
                                              </p>
                                              <div className="f-left clearfix" style={{ width: inputWidth }}>
                                                  <div className="product-select" style={{ width: '280px', marginBottom: '20px' }}>
                                                      <SelectDropDownBtn
                                                        options={dvryOptions}
                                                        placeholder="선택하세요."
                                                        onChange={handlerChangeDvryOption} />
                                                  </div>


                                                  <TextArea
                                                    placeholder="배송 요청사항을 기입해주세요"
                                                    height="160px" onChange={handleDvryText}
                                                    visible={isTextArea}
                                                    value={reqDlrv}
                                                  />

                                              </div>

                                          </div>
                                      </div>
                                  </div>

                                  <div className="default-table margin_b-50">
                                      <div className="clearfix">
                                          <h3 className="dt-title f-left">주문자 정보</h3>
                                      </div>

                                      <div className="input-box border">
                                          <div className="clearfix margin_b-10">
                                              <p className="f-left">
                                                  <label htmlFor="" className="pro_dt-label">주문자</label>
                                              </p>
                                              <div className="f-left">
                                                  <NormalInput
                                                    type="text"
                                                    width={inputWidth}
                                                    defaultValue={esItemInfo.userinfo.rqst_nm}
                                                    marginBottom='10px'
                                                    disabled={true} />

                                              </div>
                                          </div>

                                          <div className="clearfix margin_b-10">
                                              <p className="f-left">
                                                  <label htmlFor="" className="pro_dt-label">연락처</label>
                                              </p>
                                              <div className="f-left clearfix">
                                                  <div style={{ display: 'inline-block' }}>
                                                      <NormalInput
                                                        type="text"
                                                        width="80px"
                                                        defaultValue={mymobile1}
                                                        value={mymobile1}
                                                        marginBottom='10px'
                                                        disabled={true}
                                                      />
                                                  </div>

                                                  <span className="tell-hp">-</span>
                                                  <div style={{ display: 'inline-block' }} >
                                                      <NormalInput
                                                        type="text"
                                                        width="80px"
                                                        marginBottom='10px'
                                                        disabled={true}
                                                        defaultValue={mymobile2}
                                                        value={mymobile2}
                                                      />
                                                  </div>

                                                  <span className="tell-hp">-</span>
                                                  <div style={{ display: 'inline-block' }} >
                                                      <NormalInput
                                                        type="text"
                                                        width="80px"
                                                        marginBottom='10px'
                                                        disabled={true}
                                                        defaultValue={mymobile3}
                                                        value={mymobile3}
                                                      />
                                                  </div>
                                              </div>
                                          </div>

                                          <div className="clearfix">
                                              <p className="f-left">
                                                  <label htmlFor="" className="pro_dt-label">이메일</label>
                                              </p>
                                              <div className="f-left clearfix">
                                                  <div className="margin_b-10">
                                                      <NormalInput
                                                        type="text"
                                                        width={inputWidth}
                                                        marginBottom='10px'
                                                        disabled={true}
                                                        defaultValue={esItemInfo.userinfo.rqst_id}
                                                      />
                                                      <span className="ess_text">*주문하신 내역은 메일과 연락처로 발송됩니다.</span>

                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>


                                  <div className="default-table margin_b-50">
                                      <h3 className="dt-title">결제 정보</h3>
                                      <div className="clearfix border tpad">
                                          <div className="payment_select-wrap clearfix" >
                                              <button type="button" className={method === 'card' ? "ps-btn card active" : "ps-btn card"}
                                                      onClick={() => { handleMethodClick("card") }}>
                                                  신용 / 체크카드
                                              </button>
                                              <button type="button" className={method === 'vbank' ? "ps-btn send active" : "ps-btn send"}
                                                      onClick={() => { handleMethodClick("vbank") }}>
                                                  무통장입금
                                              </button>
                                              <button type="button" className={method === 'bank' ? "ps-btn live active" : "ps-btn live"}
                                                      onClick={() => { handleMethodClick("bank") }}>
                                                  실시간 계좌 이체
                                              </button>
                                              {/* <button type="button" className={ method === 'kakao' ? "ps-btn kakao active" : "ps-btn kakao"}
                                                            onClick={()=>{handleMethodClick("kakao")}}>
                                                            카카오페이
                                                        </button> */}
                                              {/* <button type="button" class="ps-btn naver">네이버페이</button> */}
                                          </div>
                                          <div className="payment_select-text">
                                              <p className="ps-text" style={{ display: method === 'card' ? 'block' : 'none' }}>
                                                  국내 모든 카드 사용이 가능하며, 해외 발행 카드는 이용하실 수 없습니다. (해외배송 불가)
                                                  <br />
                                                  금요일 오후 6시~ 월요일 오전 10시 주문은 결제 완료 후 취소 요청 시 고객 센터로 연락 바랍니다.
                                              </p>
                                              <div className="ps-text" style={{ display: method === 'vbank' ? 'block' : 'none' }}>
                                                  {/* <div className="margin_b-20">


                                                                <CheckBoxInput title="에스크로 진행 (결제대금 예치)"
                                                                    labelmargin="0px 0px 0px 5px"
                                                                    margin="0px"
                                                                    onClick={handleEscrowClick}
                                                                    defaultValue={escrow} />
                                                            </div> */}
                                                  <div>
                                                      {/* <p className="answer-text margin_b-20">에스크로 안내</p> */}
                                                      <p>
                                                          입금 기한 : 주문 기준일 +3일
                                                          <br />
                                                          무통장 입금 시 사용되는 가상 계좌는 매 주문 시마다 새로운 계좌번호(개인전용)가 부여되며 해당 주문에만 유효합니다.<br />
                                                          다른 주문 건에 대한 가상계좌로 입금하시거나 잘못된 계좌로 입금하시면 자동 입금 확인이 되지 않으며, 다른 계좌번호로 잘못 입력하신 경우에는 고객센터로 문의 주시기 바랍니다.<br />
                                                          계좌번호는 가구견적 -  주문 견적서 탭에서 확인 할 수 있으며 sms 문자 안내도 드립니다.
                                                      </p>
                                                  </div>
                                              </div>
                                              <p className="ps-text" style={{ display: method === 'bank' ? 'block' : 'none' }}>
                                                  실시간 이체 결제시 화면 아래 '결제하기'버튼을 클릭하시면 실시간 이체 결제 창이 나타납니다.<br />
                                                  실시간 이체 결제 창을 통해 입력되는 고객님의 정보는 128bit로 안전하게 암호화되어 전송되며 승인 처리 후 정보는 승인 성공/ 실패 여부에 상관없이 자동 으로 폐기되므로, 안전합니다.<br />
                                                  실시간 이체 결제 신청 시 승인 진행에 다소 시간이 소요될 수 있으므로 '중지', '새로고침'을 누르지 마시고 결과 화면이 나타날 때까지 기다려 주세요.<br />
                                                  신용카드/ 실시간 이체는 결제 후, 무통장입금은 입금확인 후 배송이 진행됩니다.<br />
                                                  금요일 오후 6시~ 월요일 오전 10시 주문은 결제 완료 후 취소 요청 시 고객 센터로 연락 바랍니다.<br />
                                                  어디가구는 구매안전서비스로 에스크로 서비스에 가입되어있습니다.<br />
                                                  현금거래에 대해 에스크로 서비스를 받으시려면 [무통장 입금] 결제방식을 선택하시기 바랍니다.<br />
                                                  온라인 실시간 계좌 이체 서비스는 은행계좌만 있으면 누구나 이용하실 수 있는 서비스로, 별도의 신청없이 그 대금을 자신의 거래은행의 계좌로부터 바로 지불하는 서비스입니다.<br />
                                                  안전한 거래를 위해 결제시 공인인증서가 반드시 필요합니다.은행 이용가능 서비스 시간은 은행 사정에 따라 다소 변동될 수 있습니다.
                                              </p>
                                              <p className="ps-text" style={{ display: method === 'kakao' ? 'block' : 'none' }}>
                                                  카카오 페이 간편 결제 혜택 및 할부 적용 여부는 해당 카드사 정책에 따라 변경될 수 있습니다.
                                                  <br />
                                                  자세한 내용은 카카오페이에서 제공하는 카드사별 정책을 확인해주세요.
                                              </p>
                                              <p className="ps-text">
                                                  주문 변경 시 카드사 혜택 및 할부 적용 여부는 해당 카드사 정책에 따라 변경될 수 있습니다.
                                              </p>
                                          </div>
                                      </div>

                                  </div>

                              </div>


                              <div className="payment_wing-box">
                                  <h3 className="dt-title">결제금액</h3>

                                  <div className="pw-box">
                                      <p className="pw-pay">
                                          <span> {Number(esItemInfo.items[0].es_pay_price.toFixed(1)).toLocaleString()}</span>원
                                      </p>

                                      <dl className="pw-dl clearfix">
                                          <dt>총 수량</dt>
                                          <dd><span>{esItemInfo.items[0].total_qty}</span>개</dd>
                                          <dt>총 견적 상품 금액</dt>
                                          <dd><span>{Number(esItemInfo.items[0].es_final_price.toFixed(1)).toLocaleString()}</span>원</dd>
                                          <dt>{esItemInfo.items[0].es_detail_dlvry_pay_type === '025202' ? "예상 착불 배송비" : "배송비"}</dt>
                                          <dd><span> {Number(esItemInfo.items[0].es_dlvry_total_price.toFixed(1)).toLocaleString()}</span>원</dd>
                                      </dl>

                                      <hr />

                                      <div className="input-box">


                                          <CheckBoxInput title="주문하실 상품 및 결제, 주문 정보
                                                확인하였으며, 이에 동의합니다. (필수)"
                                                         onClick={handleAgreeClick}
                                                         defaultValue={agree} />

                                      </div>
                                  </div>

                                  <button type="submit" className="pw-btn black-btn" onClick={handleSubmit}>결제하기</button>
                              </div>


                          </div>

                  </div>
                  :
                  <div className="small-section">
                      <div className="sz-wrap">
                          <div className="pay-title small clearfix">
                              <h2 className="f-left">견적서 주문</h2>
                          </div>

                          <div className="es_title-box margin_b-70">
                              <h3 className="es_title_sub">{esItemInfo.userinfo.pckg_nm}</h3>
                          </div>

                          <div className="margin_b-60">
                              <span className="f-left"><b>견적 주문 내역</b></span>

                              <div className="filter-fc f-right clearfix">
                                  <p>
                                      {esItemInfo.brandinfo.brnd_han}
                                      <span className="d-inline margin_l-20 font-mont">NO. {esItemInfo.userinfo.es_rqst_id}</span>
                                  </p>
                              </div>
                          </div>

                          <div className="product-table default-table">
                              <table>
                                  <colgroup>
                                      <col width="550px;" />
                                      <col width="156px;" />
                                      <col width="156px;" />
                                      <col width="156px;" />
                                      <col width="156px;" />
                                  </colgroup>

                                  <thead>
                                  <tr>
                                      <th>상품 정보</th>
                                      <th>상품 금액</th>
                                      <th>할인 금액</th>
                                      <th>배송비</th>
                                      <th>견적 금액</th>
                                  </tr>
                                  </thead>

                                  <tbody>
                                  {
                                      esItemInfo.items.map((curitem, index) => {
                                          return (<tr key={index}>
                                                <td className="pt_title-box clearfix">
                                                    <div className="product-thumbnail f-left">
                                                        <div className="ed-front">
                                                            <img src={curitem.repr_img} alt="" />
                                                        </div>
                                                        <div className="ed-back">
                                                            <a href="#"><span>{getCateName(curitem.cate_name)}</span></a>
                                                        </div>
                                                    </div>
                                                    <div className="product-title f-left">
                                                        <p className="pt-title">
                                                            <a href="#">{curitem.prdct_nm}</a>
                                                        </p>
                                                        <div className="pt-option">
                                                            <p><span>{curitem.opt_nm}</span></p>
                                                            <p>수량 : <span>{curitem.qty}</span>개</p>
                                                        </div>
                                                    </div>
                                                </td>
                                                {/* 상품금액 */}
                                                <td className="text_center">
                                                    {getDscntPercent(curitem)}
                                                    <p className="fontsize-14"><span className="font-mont">
                                                        {Number(curitem.es_detail_prdct_price.toFixed(1)).toLocaleString()}
                                                    </span>원</p>
                                                </td>
                                                {/* 할인금액 */}
                                                <td className="text_center">
                                                    {getDscntPriceNoDot(curitem)}
                                                    {getAddDscntPrice(curitem)}
                                                </td>
                                                {/* 배송비 */}
                                                <td className="text_center">
                                                    <div style={isCashOnDlvryShow(curitem)}>
                                                        <p className="fontsize-14 gray-text">착불 배송비</p>
                                                    </div>
                                                    {getDetailDlvry(curitem)}

                                                </td>
                                                {/* 견적금액 */}
                                                <td className="text_center">
                                                    <p className="pt-pay"><span className="font-mont">
                                                        {Number(curitem.es_detail_total_price.toFixed(1)).toLocaleString()}</span>원</p>
                                                </td>
                                            </tr>
                                          )
                                      })
                                  }
                                  </tbody>

                                  <tfoot>
                                  <tr className="total-pay_tr">
                                      <td className="mint text_center">
                                          총 수량 <span className="font-mont">{esItemInfo.items[0].total_qty}</span>개
                                      </td>
                                      <td className="mint text_center">
                                          <div className="total-pay minus-icon">
                                              <p className="pt-pay"><span className="font-mont">
                                                    {Number(esItemInfo.items[0].es_prdct_total_price.toFixed(1)).toLocaleString()}
                                                </span><span className="medium">원</span></p>
                                          </div>
                                      </td>
                                      <td className="mint text_center">
                                          <div className="total-pay plus-icon">
                                              <p className="pt-pay pink">
                                                  <span className="font-mont">{getTotalDsctPrice(esItemInfo.items[0])}</span>
                                                  <span className="medium">원</span></p>
                                          </div>
                                      </td>
                                      <td className="mint text_center">
                                          <div className="total-pay equal-icon">
                                              <div style={isCashOnDlvryShow(esItemInfo.items[0])}>
                                                  <p className="total-absolute fontsize-14 gray-text">착불 배송비</p>
                                              </div>
                                              {getDlvryPayInFooter(esItemInfo.items[0])}
                                          </div>
                                      </td>
                                      <td className="mint text_center">
                                          <div className="total-pay">
                                              <p className="pt-pay"><span className="font-mont">
                                                    {Number(esItemInfo.items[0].es_pay_price.toFixed(1)).toLocaleString()}
                                                </span><span className="medium">원</span></p>
                                          </div>
                                      </td>
                                  </tr>
                                  {/* #2676 - 이슈 요청으로 희망 견적 금액 삭제  */}
                                  {/* <tr>
                                        <td colSpan="3"></td>
                                        <td colSpan="2" className="hope_pay text_center">
                                            <span className="fontsize-15 gray-text">
                                                희망 견적 금액
                                                    <span className="font-mont" style={{ marginLeft: '10px' }}>
                                                    {Number(esItemInfo.items[0].rqst_price.toFixed(1)).toLocaleString()}
                                                </span>
                                                <span className="medium">원</span>
                                            </span>
                                        </td>
                                    </tr> */}
                                  </tfoot>
                              </table>

                          </div>

                          <div className="payment-wrap clearfix margin_t-40">

                              <div className="payment_con-wrap">

                                  <div className="default-table margin_b-50">
                                      <h3 className="dt-title f-left">배송지 정보</h3>
                                      <div className="f-right margin_b-10">
                                          <CheckBoxInput
                                            labelmargin="0px 0px 0px 10px"
                                            title="주문자 정보와 동일"
                                            onClick={handleSameOrderInfo}
                                            defaultValue={same} />
                                      </div>
                                      <table>
                                          <tbody>
                                          <tr className="one_tr">
                                              <td className="border_bottom">
                                                  <div className="input-box">
                                                      <div className="clearfix margin_b-10">
                                                          <p className="f-left">
                                                              <label htmlFor="" className="pro_dt-label">배송 지역</label>
                                                          </p>
                                                          <div className="f-left">
                                                              <NormalInput
                                                                type="text"
                                                                width={inputWidth}
                                                                defaultValue={esItemInfo.userinfo.addr1}
                                                                disabled={true}
                                                                marginBottom='10px'
                                                              />
                                                              <NormalInput
                                                                type="text"
                                                                width={inputWidth}
                                                                defaultValue={esItemInfo.userinfo.addr2}
                                                                disabled={true}
                                                                marginBottom='10px'
                                                              />
                                                              <span className="ess_text">*배송 주소로 견적이 진행되어 변경 불가합니다</span>
                                                          </div>
                                                      </div>

                                                      <div className="clearfix margin_b-10">
                                                          <p className="f-left">
                                                              <label htmlFor="" className="pro_dt-label">수령인</label>
                                                          </p>
                                                          <div className="f-left">
                                                              <NormalInput
                                                                inputRef={recvNmRef}
                                                                type="text"
                                                                width={inputWidth}
                                                                defaultValue={getRecvName()}
                                                                marginBottom='10px'
                                                                onChange={hanldeRevNameInput}
                                                              />
                                                          </div>
                                                      </div>
                                                      <div className="clearfix margin_b-10">
                                                          <p className="f-left">
                                                              <label htmlFor="" className="pro_dt-label">연락처 1</label>
                                                          </p>
                                                          <div className="f-left clearfix">
                                                              <div style={{ display: 'inline-block' }}>
                                                                  <NormalInput
                                                                    inputRef={mbRef1}
                                                                    type="text"
                                                                    width="80px"
                                                                    defaultValue={mobile1}
                                                                    marginBottom='10px'
                                                                    maxLength="3"
                                                                    onChange={handleMobile1}
                                                                  />
                                                              </div>

                                                              <span className="tell-hp">-</span>
                                                              <div style={{ display: 'inline-block' }} >
                                                                  <NormalInput
                                                                    inputRef={mbRef2}
                                                                    defaultValue={mobile2}
                                                                    type="text"
                                                                    width="80px"
                                                                    marginBottom='10px'
                                                                    maxLength="4"
                                                                    onChange={handleMobile2}
                                                                  />
                                                              </div>

                                                              <span className="tell-hp">-</span>
                                                              <div style={{ display: 'inline-block' }} >
                                                                  <NormalInput
                                                                    inputRef={mbRef3}
                                                                    defaultValue={mobile3}
                                                                    type="text"
                                                                    width="80px"
                                                                    marginBottom='10px'
                                                                    maxLength="4"
                                                                    onChange={handleMobile3}
                                                                  />
                                                              </div>
                                                          </div>
                                                      </div>

                                                      <div className="clearfix margin_b-10">
                                                          <p className="f-left">
                                                              <label htmlFor="" className="pro_dt-label">연락처 2</label>
                                                          </p>
                                                          <div className="f-left clearfix">
                                                              <div style={{ display: 'inline-block' }}>
                                                                  <NormalInput
                                                                    type="text"
                                                                    width="80px"
                                                                    defaultValue="010"
                                                                    marginBottom='10px'
                                                                    onChange={handlePhone1}
                                                                  />
                                                              </div>

                                                              <span className="tell-hp">-</span>
                                                              <div style={{ display: 'inline-block' }} >
                                                                  <NormalInput
                                                                    type="text"
                                                                    width="80px"
                                                                    marginBottom='10px'
                                                                    onChange={handlePhone2}
                                                                  />
                                                              </div>

                                                              <span className="tell-hp">-</span>
                                                              <div style={{ display: 'inline-block' }} >
                                                                  <NormalInput
                                                                    type="text"
                                                                    width="80px"
                                                                    marginBottom='10px'
                                                                    onChange={handlePhone3}
                                                                  />
                                                              </div>
                                                          </div>
                                                      </div>

                                                      <div className="clearfix">
                                                          <p className="f-left">
                                                              <label htmlFor="" className="pro_dt-label">배송 요청사항</label>
                                                          </p>
                                                          <div className="f-left clearfix" style={{ width: inputWidth }}>
                                                              <div className="product-select" style={{ width: '280px', marginBottom: '20px' }}>
                                                                  <SelectDropDownBtn
                                                                    options={dvryOptions}
                                                                    placeholder="선택하세요."
                                                                    onChange={handlerChangeDvryOption} />
                                                              </div>


                                                              <TextArea
                                                                placeholder="배송 요청사항을 기입해주세요"
                                                                height="160px" onChange={handleDvryText}
                                                                visible={isTextArea}
                                                                value={reqDlrv}
                                                              />

                                                          </div>

                                                      </div>
                                                  </div>
                                              </td>
                                          </tr>
                                          </tbody>
                                      </table>

                                  </div>

                                  <div className="default-table margin_b-50">
                                      <div className="clearfix">
                                          <h3 className="dt-title f-left">주문자 정보</h3>
                                      </div>

                                      <table>
                                          <tbody>
                                          <tr className="one_tr">
                                              <td className="border_bottom">
                                                  <div className="input-box">
                                                      <div className="clearfix margin_b-10">
                                                          <p className="f-left">
                                                              <label htmlFor="" className="pro_dt-label">주문자</label>
                                                          </p>
                                                          <div className="f-left">
                                                              <NormalInput
                                                                type="text"
                                                                width={inputWidth}
                                                                defaultValue={esItemInfo.userinfo.rqst_nm}
                                                                marginBottom='10px'
                                                                disabled={true} />

                                                          </div>
                                                      </div>

                                                      <div className="clearfix margin_b-10">
                                                          <p className="f-left">
                                                              <label htmlFor="" className="pro_dt-label">연락처</label>
                                                          </p>
                                                          <div className="f-left clearfix">
                                                              <div style={{ display: 'inline-block' }}>
                                                                  <NormalInput
                                                                    type="text"
                                                                    width="80px"
                                                                    defaultValue={mymobile1}
                                                                    value={mymobile1}
                                                                    marginBottom='10px'
                                                                    disabled={true}
                                                                  />
                                                              </div>

                                                              <span className="tell-hp">-</span>
                                                              <div style={{ display: 'inline-block' }} >
                                                                  <NormalInput
                                                                    type="text"
                                                                    width="80px"
                                                                    marginBottom='10px'
                                                                    disabled={true}
                                                                    defaultValue={mymobile2}
                                                                    value={mymobile2}
                                                                  />
                                                              </div>

                                                              <span className="tell-hp">-</span>
                                                              <div style={{ display: 'inline-block' }} >
                                                                  <NormalInput
                                                                    type="text"
                                                                    width="80px"
                                                                    marginBottom='10px'
                                                                    disabled={true}
                                                                    defaultValue={mymobile3}
                                                                    value={mymobile3}
                                                                  />
                                                              </div>
                                                          </div>
                                                      </div>

                                                      <div className="clearfix">
                                                          <p className="f-left">
                                                              <label htmlFor="" className="pro_dt-label">이메일</label>
                                                          </p>
                                                          <div className="f-left clearfix">
                                                              <div className="margin_b-10">
                                                                  <NormalInput
                                                                    type="text"
                                                                    width={inputWidth}
                                                                    marginBottom='10px'
                                                                    disabled={true}
                                                                    defaultValue={esItemInfo.userinfo.rqst_id}
                                                                  />
                                                                  <span className="ess_text">*주문하신 내역은 메일과 연락처로 발송됩니다.</span>

                                                              </div>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </td>
                                          </tr>
                                          </tbody>
                                      </table>
                                  </div>


                                  <div className="default-table">
                                      <div className="clearfix">
                                          <h3 className="dt-title f-left">결제 정보</h3>

                                          {/* <div className="f-right margin_b-10">
                                            <button type="button" className="answer-text small pop_open" data-popup="cardInfoOpenPop">무이자 카드 안내</button>
                                        </div> */}
                                      </div>

                                      <table>
                                          <tbody>
                                          <tr className="one_tr">
                                              <td className="border_bottom">
                                                  <div className="payment_select-wrap clearfix">
                                                      <button type="button" className={method === 'card' ? "ps-btn card active" : "ps-btn card"}
                                                              onClick={() => { handleMethodClick("card") }}>
                                                          신용 / 체크카드
                                                      </button>
                                                      <button type="button" className={method === 'vbank' ? "ps-btn send active" : "ps-btn send"}
                                                              onClick={() => { handleMethodClick("vbank") }}>
                                                          무통장입금
                                                      </button>
                                                      <button type="button" className={method === 'bank' ? "ps-btn live active" : "ps-btn live"}
                                                              onClick={() => { handleMethodClick("bank") }}>
                                                          실시간 계좌 이체
                                                      </button>
                                                      {/* <button type="button" className={ method === 'kakao' ? "ps-btn kakao active" : "ps-btn kakao"}
                                                            onClick={()=>{handleMethodClick("kakao")}}>
                                                            카카오페이
                                                        </button> */}
                                                      {/* <button type="button" class="ps-btn naver">네이버페이</button> */}
                                                  </div>

                                                    <div className="payment_select-text">
                                                        <p className="ps-text" style={{ display: method === 'card' ? 'block' : 'none' }}>
                                                            국내 모든 카드 사용이 가능하며, 해외 발행 카드는 이용하실 수 없습니다. (해외배송 불가)
                                                            <br />
                                                            금요일 오후 6시~ 월요일 오전 10시 주문은 결제 완료 후 취소 요청 시 고객 센터로 연락 바랍니다.
                                                        </p>
                                                        <div className="ps-text" style={{ display: method === 'vbank' ? 'block' : 'none' }}>
                                                            <div className="margin_b-20">


                                                                <CheckBoxInput title="에스크로 진행 (결제대금 예치)"
                                                                    labelmargin="0px 0px 0px 5px"
                                                                    margin="0px"
                                                                    onClick={handleEscrowClick}
                                                                    defaultValue={escrow} />
                                                            </div>
                                                            <div>
                                                                {/* <p className="answer-text margin_b-20">에스크로 안내</p> */}
                                                                <p>
                                                                    입금 기한 : 주문 기준일 +3일
                                                                    <br />
                                                                        무통장 입금 시 사용되는 가상 계좌는 매 주문 시마다 새로운 계좌번호(개인전용)가 부여되며 해당 주문에만 유효합니다.<br />
                                                                        다른 주문 건에 대한 가상계좌로 입금하시거나 잘못된 계좌로 입금하시면 자동 입금 확인이 되지 않으며, 다른 계좌번호로 잘못 입력하신 경우에는 고객센터로 문의 주시기 바랍니다.<br />
                                                                        계좌번호는 가구견적 -  주문 견적서 탭에서 확인 할 수 있으며 sms 문자 안내도 드립니다.
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <p className="ps-text" style={{ display: method === 'bank' ? 'block' : 'none' }}>
                                                            실시간 이체 결제시 화면 아래 '결제하기'버튼을 클릭하시면 실시간 이체 결제 창이 나타납니다.<br />
                                                            실시간 이체 결제 창을 통해 입력되는 고객님의 정보는 128bit로 안전하게 암호화되어 전송되며 승인 처리 후 정보는 승인 성공/ 실패 여부에 상관없이 자동 으로 폐기되므로, 안전합니다.<br />
                                                            실시간 이체 결제 신청 시 승인 진행에 다소 시간이 소요될 수 있으므로 '중지', '새로고침'을 누르지 마시고 결과 화면이 나타날 때까지 기다려 주세요.<br />
                                                            신용카드/ 실시간 이체는 결제 후, 무통장입금은 입금확인 후 배송이 진행됩니다.<br />
                                                            금요일 오후 6시~ 월요일 오전 10시 주문은 결제 완료 후 취소 요청 시 고객 센터로 연락 바랍니다.<br />
                                                            어디가구는 구매안전서비스로 에스크로 서비스에 가입되어있습니다.<br />
                                                            현금거래에 대해 에스크로 서비스를 받으시려면 [무통장 입금] 결제방식을 선택하시기 바랍니다.<br />
                                                            온라인 실시간 계좌 이체 서비스는 은행계좌만 있으면 누구나 이용하실 수 있는 서비스로, 별도의 신청없이 그 대금을 자신의 거래은행의 계좌로부터 바로 지불하는 서비스입니다.<br />
                                                            안전한 거래를 위해 결제시 공인인증서가 반드시 필요합니다.은행 이용가능 서비스 시간은 은행 사정에 따라 다소 변동될 수 있습니다.
                                                        </p>
                                                        <p className="ps-text" style={{ display: method === 'kakao' ? 'block' : 'none' }}>
                                                            카카오 페이 간편 결제 혜택 및 할부 적용 여부는 해당 카드사 정책에 따라 변경될 수 있습니다.
                                                            <br />
                                                                    자세한 내용은 카카오페이에서 제공하는 카드사별 정책을 확인해주세요.
                                                        </p>
                                                        <p className="ps-text">
                                                            주문 변경 시 카드사 혜택 및 할부 적용 여부는 해당 카드사 정책에 따라 변경될 수 있습니다.
                                                        </p>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                              </div>


                              <div className="payment_wing-box">
                                  <h3 className="dt-title">결제금액</h3>

                                  <div className="pw-box">
                                      <p className="pw-pay">
                                          <span> {Number(esItemInfo.items[0].es_pay_price.toFixed(1)).toLocaleString()}</span>원
                                      </p>

                                      <dl className="pw-dl clearfix">
                                          <dt>총 수량</dt>
                                          <dd><span>{esItemInfo.items[0].total_qty}</span>개</dd>
                                          <dt>총 견적 상품 금액</dt>
                                          <dd><span>{Number(esItemInfo.items[0].es_final_price.toFixed(1)).toLocaleString()}</span>원</dd>
                                          <dt>{esItemInfo.items[0].es_detail_dlvry_pay_type === '025202' ? "예상 착불 배송비" : "배송비"}</dt>
                                          <dd><span> {Number(esItemInfo.items[0].es_dlvry_total_price.toFixed(1)).toLocaleString()}</span>원</dd>
                                      </dl>

                                      <hr />

                                      <div className="input-box">


                                          <CheckBoxInput title="주문하실 상품 및 결제, 주문 정보
                                                확인하였으며, 이에 동의합니다. (필수)"
                                                         onClick={handleAgreeClick}
                                                         defaultValue={agree} />

                                      </div>
                                  </div>

                                  <button type="submit" className="pw-btn black-btn" onClick={handleSubmit}>결제하기</button>
                              </div>


                          </div>


                      </div>
                  </div>
                }

            </EsOrderContentsBlock>
            <Footer />
            <Modal
                isOpen={openModal}
                onRequestClose={() => setOpenModal(false)}
                style={NomalPopupOneBtnStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                {<NormalPopupOneBtn
                    text=""
                    text2="필수 정보를 입력해 주세요." text3=""
                    btn="확인" onClick={() => setOpenModal(false)}
                />}
            </Modal>
        </EsOrderBlock >
    );
};

export default EsOrder;